// Where this app is served from. Its host identifies the product.
// @ts-ignore
export const APP_URL = import.meta.env.VITE_APP_URL || window.location.origin;
// Where the API is reached: always this host's /api, which is the worker when deployed and the dev proxy locally.
// Both know the backends; the service and version are added in core/api.
export const API_ROOT = '/api';

// @ts-ignore
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined;

